import SectionTitle from "./SectionTitle";

const About = ({ minHeight }) => {
  return (
    <section
      className="about wrapper sectionAbout"
      style={minHeight ? { minHeight: "100vh" } : null}
    >
      <SectionTitle title="About" />
      <p>
        Welcome to Ariz Super Mart!
        Your one-stop destination for all your daily needs and more! At Ariz Super Mart,
        we are committed to bringing you the best products, unbeatable prices,
        and a delightful shopping experience under one roof.
      </p>

      <p>
        Your Experience Matters to Us
        At Ariz Super Mart, customer satisfaction is our top priority.
        Our friendly staff is always ready to assist, ensuring a seamless and enjoyable shopping experience.
      </p>
    </section>
  );
};

export default About;
